import ProfileWorkProfile from './ProfileWorkProfile.component';

export default ProfileWorkProfile;
